/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_modal__bookthefork2 = /** @type {(inputs: {}) => string} */ () => {
	return `Buchungs-Widget TheFork`
};

const en_modal__bookthefork2 = /** @type {(inputs: {}) => string} */ () => {
	return `TheFork booking widget`
};

const es_modal__bookthefork2 = /** @type {(inputs: {}) => string} */ () => {
	return `Widget de reserva de TheFork`
};

const fr_modal__bookthefork2 = /** @type {(inputs: {}) => string} */ () => {
	return `Widget de réservation TheFork`
};

const it_modal__bookthefork2 = /** @type {(inputs: {}) => string} */ () => {
	return `Widget di prenotazione TheFork`
};

const nl_modal__bookthefork2 = /** @type {(inputs: {}) => string} */ () => {
	return `TheFork reserveringswidget`
};

const pt_modal__bookthefork2 = /** @type {(inputs: {}) => string} */ () => {
	return `Widget de reserva do TheFork`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const modal__bookthefork2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.modal__bookthefork2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("modal__bookthefork2", locale)
	if (locale === "de") return de_modal__bookthefork2(inputs)
	if (locale === "en") return en_modal__bookthefork2(inputs)
	if (locale === "es") return es_modal__bookthefork2(inputs)
	if (locale === "fr") return fr_modal__bookthefork2(inputs)
	if (locale === "it") return it_modal__bookthefork2(inputs)
	if (locale === "nl") return nl_modal__bookthefork2(inputs)
	return pt_modal__bookthefork2(inputs)
};
export { modal__bookthefork2 as "modal__bookTheFork" }